import { LitElement, TemplateResult, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';
import innerCSS from './se-utility-nav.inner.pcss?inline';
import '../se-container/se-container';

/**
 * The SeUtilityNav component
 * @element se-utility-nav
 * @slot utility - utility nav markup
 * @slot translate - gTranslate markup/module
 */
@customElement('se-utility-nav')
export class SeUtilityNav extends LitElement {
  private stylesheetController = new AdoptedStyleSheets(this, {
    encapsulatedCSS: innerCSS,
  });

  render(): TemplateResult {
    return html`
      <section class="utility-nav--wrapper">
        <se-container>
          <div class="utility-nav">
            <slot name="utility"></slot>
            <slot name="translate"></slot>
          </div>
        </se-container>
      </section>
    `;
  }
}
